var map = {
	"./de.png": "S7d1",
	"./en.png": "pRiO",
	"./es.png": "jI5y",
	"./fr.png": "bU72",
	"./ja.png": "SrR/",
	"./ko.png": "5SPZ",
	"./pt.png": "8P2t",
	"./ru.png": "eBy4",
	"./th.png": "yPDa",
	"./zh-Hant.png": "Fy13"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "zAGC";